import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=18e5e0b6&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=18e5e0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5e0b6",
  null
  
)

export default component.exports